module.exports = __webpack_public_path__ + "img/ga.33d27fe1.svg";